import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LayoutsComponent } from '../../layouts/layouts.component';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: true,
    imports: [LayoutsComponent, RouterLink]
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  back(): void {
    window.history.back();
  }
}
